import { FC, useEffect, useRef } from "react";
import { ModalDialog } from "@rothoblaas/design-system";
import { useAuthContext } from "../../context/authContext";
import useI18n from "../../hooks/useTranslations";
import { useCategoriesApi } from "../../http/useCategories";
import { EditAdminCategoryProps } from "./AdminCategory";
import { NewEditAdminCategoryForm } from "./AdminCategoryForm";

type AdminCategoryModalProps = EditAdminCategoryProps & {
  onCloseModal: () => void;
};

export const AdminCategoryModal: FC<AdminCategoryModalProps> = ({
  categoryCode,
  onCloseModal,
}: AdminCategoryModalProps) => {
  const i18n = useI18n();
  const { permissions } = useAuthContext();
  const categoriesApi = useCategoriesApi();

  const aborter = useRef(new AbortController());

  const categorySwr = categoriesApi.getAdminCategory(categoryCode!, aborter.current.signal);

  useEffect(() => {
    categoryCode && categorySwr.trigger();
  }, [categoryCode]);

  if (!categorySwr.data && !categorySwr.error) {
    return null;
  }

  return (
    <>
      <ModalDialog title={i18n.translation.categories.edit} onClose={onCloseModal}>
        <NewEditAdminCategoryForm
          category={!categorySwr.error ? categorySwr.data : undefined}
          disabled={categorySwr.isMutating || !!categorySwr.error || !permissions.admin.canManageCategories}
          isLoading={categorySwr.isMutating}
          onClose={onCloseModal}
        />
      </ModalDialog>
    </>
  );
};
